import React from "react";

const VesselView = ({ vessel, isViewMode, setIsViewMode }) => {
  // console.log("vessel data",vessel)

  function formatPrice(price) {
    const num = parseFloat(price);
    if (isNaN(num)) return "N/A";
    return num.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  const authData =
    JSON.parse(localStorage.getItem("authData")) ||
    JSON.parse(sessionStorage.getItem("authData"));

  const userRole = authData.role;
  return (
    isViewMode && (
      <div
        className={`modal fade ${isViewMode ? "show d-block" : ""}`}
        style={{
          display: "block",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
        }}
        tabIndex="-1"
        role="dialog"
        aria-hidden={!isViewMode}
        onClick={(e) => {
          if (e.target.classList.contains("modal")) setIsViewMode(false);
        }}
      >
        <div
          className="modal-dialog modal-lg modal-dialog-centered"
          role="document"
        >
          <div
            className="modal-content"
            style={{
              border: "none",
              borderRadius: "5px",
              boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.1)",
            }}
          >
            {/* Modal Header */}
            <div
              className="modal-header"
              style={{
                borderBottom: "none",
                paddingBottom: "10px",
                textAlign: "center",
              }}
            >
              <h4
                className="modal-title w-100"
                style={{
                  fontWeight: "bold",
                  color: "#343a40",
                  textAlign: "center",
                  fontSize: "24px",
                }}
              >
                Vessel Details
              </h4>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={() => setIsViewMode(false)}
              ></button>
            </div>

            {/* Modal Body */}
            <div className="modal-body">
              <div className="row gy-4 ">
                {/* General Information Card */}
                <div className="col-12">
                  <div
                    className="card border-0 mb-2"
                    style={{
                      borderRadius: "12px",

                      padding: "10px",
                      textAlign: "left",
                    }}
                  >
                    <div className="card-body">
                      <h6
                        className="card-title"
                        style={{ fontWeight: "bold", fontSize: "18px" }}
                      >
                        <i
                          className="bi bi-water"
                          style={{ marginRight: "10px" }}
                        ></i>
                        Vessel Information
                      </h6>
                      <hr />
                      <div className="mb-3">
                        <h6 className="form-label">
                          <strong>Vessel Name:</strong>{" "}
                          {vessel?.vessel_name || "N/A"}
                        </h6>
                      </div>
                      <div className="mb-3">
                        <h6 className="form-label">
                          <strong>Project Code:</strong>{" "}
                          {vessel?.project_code || "N/A"}
                        </h6>
                      </div>
                      <div className="mb-3">
                        <h6 className="form-label">
                          <strong>Vessel Code:</strong>{" "}
                          {vessel?.vessel_code || "N/A"}
                        </h6>
                      </div>
                      <div className="mb-3">
                        <h6 className="form-label">
                          <i
                            className="bi bi-calendar"
                            style={{ marginRight: "10px" }}
                          ></i>
                          <strong>Job Start Date:</strong>{" "}
                          {vessel?.job_start
                            ? new Date(vessel.job_start).toLocaleDateString()
                            : "N/A"}
                        </h6>
                      </div>
                      <div className="mb-2">
                        <h6 className="form-label">
                          <i
                            className="bi bi-calendar"
                            style={{ marginRight: "10px" }}
                          ></i>
                          <strong>Job End Date:</strong>{" "}
                          {vessel?.job_end
                            ? new Date(vessel.job_end).toLocaleDateString()
                            : "N/A"}
                        </h6>
                      </div>
                      <div className="mb">
                        <h6 className="form-label">
                          <i
                            className="bi bi-clock"
                            style={{ marginRight: "10px" }}
                          ></i>
                          <strong>Total Hours:</strong>{" "}
                          {vessel.mechanical_dept?.total_hrs_me +
                            vessel.piping_dept?.total_hrs_pf || 0}
                        </h6>
                      </div>
                      {["admin", "superadmin"].includes(userRole) && (
                        <>
                          <div className="mb">
                            <h6 className="form-label">
                              <i
                                className="bi bi-cash-coin"
                                style={{ marginRight: "10px" }}
                              ></i>
                              <strong>Amount per Hour:</strong>{" "}
                              {(() => {
                                const totalHrsMe =
                                  vessel.mechanical_dept?.total_hrs_me || 0;
                                const totalHrsPf =
                                  vessel.piping_dept?.total_hrs_pf || 0;
                                const denominator =
                                  totalHrsMe + totalHrsPf || 1; // Prevent division by zero
                                const result =
                                  vessel.total_amount_from_invoices /
                                  denominator;
                                //  console.log(vessel.total_amount_from_invoices);

                                return `$ ${formatPrice(result.toFixed(2))}`; // Format result to 2 decimal places
                              })()}
                            </h6>
                          </div>
                          <div className="mb">
                            <h6 className="form-label">
                              <i
                                className="bi bi-cash-coin"
                                style={{ marginRight: "10px" }}
                              ></i>
                              <strong>Total Amount form Invoice:</strong>{" "}
                              {`$ ${formatPrice(vessel.total_amount_from_invoices) ?? 0}`}
                            </h6>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>

                {/* Piping Department Card */}
                {/* <div className="col-md-6">
                  <div
                    className="card border-0 mb-2"
                    style={{
                      borderRadius: "12px",
                      backgroundColor: "#f2f3f4",
                      padding: "10px",
                      textAlign: "left",
                    }}
                  >
                    <div className="card-body">
                      <h5
                        className="card-title"
                        style={{ fontWeight: "bold", fontSize: "18px" }}
                      >
                        <i
                          className="bi bi-gear"
                          style={{ marginRight: "10px" }}
                        ></i>
                        Piping Department
                      </h5>
                      <hr />
                      <div className="mb-3">
                        <h6 className="form-label">
                          <strong>Trade:</strong>{" "}
                          {vessel?.piping_dept?.trade || "N/A"}
                        </h6>
                      </div>
                      <div className="mb-3">
                        <h6 className="form-label">
                          <strong>Manual Entry Hours:</strong>{" "}
                          {vessel?.piping_dept?.manual_entry_hrs || 0}
                        </h6>
                      </div>
                      <div className="mb-0">
                        <h6 className="form-label">
                          <strong>ISRP Main Hours:</strong>{" "}
                          {vessel?.piping_dept?.isrp_main_hrs || 0}
                        </h6>
                      </div>
                      <div className="mb-0">
                        <h6 className="form-label">
                          <strong>ISRP Main Hours:</strong>{" "}
                          {vessel?.piping_dept?.total_hrs_pf || 0}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div> */}

                {/* Mechanical Department Card */}
                {/* <div className="col-md-6">
                  <div
                    className="card border-0  mb-2"
                    style={{
                      borderRadius: "12px",
                      backgroundColor: "#f2f3f4",
                      padding: "10px",
                      textAlign: "left",
                    }}
                  >
                    <div className="card-body">
                      <h5
                        className="card-title"
                        style={{ fontWeight: "bold", fontSize: "18px" }}
                      >
                        <i
                          className="bi bi-gear"
                          style={{ marginRight: "10px" }}
                        ></i>
                        Mechanical Department
                      </h5>
                      <hr />
                      <div className="mb-3">
                        <h6 className="form-label">
                          <strong>Trade:</strong>{" "}
                          {vessel?.mechanical_dept?.trade || "N/A"}
                        </h6>
                      </div>
                      <div className="mb-3">
                        <h6 className="form-label">
                          <strong>Manual Entry Hours:</strong>{" "}
                          {vessel?.mechanical_dept?.manual_entry_hrs || 0}
                        </h6>
                      </div>
                      <div className="mb-0">
                        <h6 className="form-label">
                          <strong>ISRP Main Hours:</strong>{" "}
                          {vessel?.mechanical_dept?.isrp_main_hrs || 0}
                        </h6>
                      </div>
                      <div className="mb-0">
                        <h6 className="form-label">
                          <strong>ISRP Main Hours:</strong>{" "}
                          {vessel?.mechanical_dept?.total_hrs_me || 0}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default VesselView;
